module.exports = __webpack_public_path__ + "static/21-53a7eb2e801f0074faf1ab6cc9cacb5f.jpg";